import { render, staticRenderFns } from "./characteristic.vue?vue&type=template&id=34204cc4&"
import script from "./characteristic.vue?vue&type=script&lang=js&"
export * from "./characteristic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34204cc4')) {
      api.createRecord('34204cc4', component.options)
    } else {
      api.reload('34204cc4', component.options)
    }
    module.hot.accept("./characteristic.vue?vue&type=template&id=34204cc4&", function () {
      api.rerender('34204cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/characteristic.vue"
export default component.exports